<template>
  <div>
    <div class="text-size-14 text-mild">
      {{ title }}
      <AppLabel :variant="appLabelVariant">{{ appLabelText }}</AppLabel>
    </div>
    <div class="upload-image-area mt-2 p-4">
      <div class="mb-4">
        <slot />
      </div>
      <div class="action-buttons">
        <AppButtonOutline @click="onClickCameraButton">
          <div class="d-flex justify-content-center align-items-center">
            <FeatherIcon icon="camera" size="16" />
            <p class="text-size-14 button-text ml-2">
              カメラ撮影
            </p>
          </div>
        </AppButtonOutline>
        <AppButtonOutline @click="onClickSelectButton">
          <div class="d-flex justify-content-center align-items-center">
            <FeatherIcon icon="upload" size="16" />
            <p class="text-size-14 button-text ml-2">
              ファイル選択
            </p>
          </div>
        </AppButtonOutline>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import AppLabel from "@/components/atoms/input/AppLabel.vue";
import AppButtonOutline from "@/components/atoms/button/AppButtonOutline.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";

@Component({
  components: {
    AppLabel,
    AppButtonOutline,
    FeatherIcon
  }
})
export default class UploadImageArea extends Vue {
  @Prop({
    type: String,
    default: "写真アップロード"
  })
  title!: string;

  @Prop({
    type: String,
    default: ""
  })
  appLabelText!: string;

  @Prop({
    type: String,
    default: "red"
  })
  appLabelVariant!: string;

  onClickCameraButton() {
    this.$emit("clickCamera");
  }

  onClickSelectButton() {
    this.$emit("clickSelect");
  }
}
</script>

<style lang="scss" scoped>
.upload-image-area {
  background-color: $white;
  border: 1px solid $gray-02;
  border-radius: 4px;

  .action-buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;

    .button-text {
      line-height: 14px;
    }
  }
}
</style>
